export const CardTypeEnums = {
  // 自定义组件
  CUSTOM_COMPONENT: 'CustomComponent',
  // 品质承诺
  COMMITMENT_QUALITY_INFORMATION: 'CommitmentQualityInformation',
  // 赔付承诺
  COMMODITY_COMMITMENT_INFORMATION: 'CommodityCommitmentInformation',
  // 产品介绍
  COMMODITY_PRODUCT_INFORMATION: 'CommodityProductInformation',
  // 产品溯源信息
  COMMODITY_PRODUCT_TRACEABILITY: 'CommodityProductTraceability',
  // 湾区认证信息
  COMMODITY_BAY_AREA_CERTIFIED: 'CommodityBayAreaCertified',
  // 我们的故事
  OUR_STORY: 'OurStory'
}

export const CardTypeList = [
  {
    key: CardTypeEnums.CUSTOM_COMPONENT,
    componentName: 'CustomComponent'
  },
  {
    key: CardTypeEnums.COMMITMENT_QUALITY_INFORMATION,
    componentName: 'QualityCommitment'
  },
  {
    key: CardTypeEnums.COMMODITY_COMMITMENT_INFORMATION,
    componentName: 'CompensationCommitment'
  },
  {
    key: CardTypeEnums.COMMODITY_PRODUCT_INFORMATION,
    componentName: 'ProductInformation'
  },
  {
    key: CardTypeEnums.COMMODITY_PRODUCT_TRACEABILITY,
    componentName: 'WayInformation'
  },
  {
    key: CardTypeEnums.COMMODITY_BAY_AREA_CERTIFIED,
    componentName: 'AuthenticationInformation'
  },
  {
    key: CardTypeEnums.OUR_STORY,
    componentName: 'OurStory'
  }
]


export function getComponentNameByCardTypeEnums(cardTypeEnums) {
  let node = CardTypeList.find(item => item.key === cardTypeEnums)
  return node ? node.componentName : ''
}
